
export const financialRouter = [
  {
    path: "/financial/overview",
    name: "overview",
    meta : { title: "GPUEZ智算云 - 财务概览" },
    component: resolve => require(["@/page/control/financial/overview/overview"], resolve),
  },
  {
    path: "/financial/overview/consumeWar",
    name: "consumeWar",
    meta : { title: "GPUEZ智算云 - 高额消费预警" },
    component: resolve => require(["@/page/control/financial/overview/consumeWar"], resolve),
  },
  {
    path: "/financial/overview/withdraw",
    name: "withdraw",
    meta : { title: "GPUEZ智算云 - 提现" },
    component: resolve => require(["@/page/control/financial/overview/withdraw"], resolve),
  },
  {
    path: "/financial/recharge",
    name: "recharge",
    meta : { title: "GPUEZ智算云 - 账户充值" },
    component: resolve => require(["@/page/control/financial/recharge/recharge"], resolve),
  },
  // 账单管理
  {
    path: "/financial/bills/settlement",
    name: "settlement",
    meta : { title: "GPUEZ智算云 - 收支明细" },
    component: resolve => require(["@/page/control/financial/bills/settlement"], resolve),
  },
  {
    path: "/financial/bills/summarys",
    name: "summarys",
    meta : { title: "GPUEZ智算云 - 账单管理" },
    component: resolve => require(["@/page/control/financial/bills/summarys"], resolve),
  },
  {
    path: "/financial/bills/voucher",
    name: "voucher",
    meta: { title: "GPUEZ智算云 - 代金券" },
    component: resolve => require(["@/page/control/financial/bills/voucher"], resolve),
  },
  // 发票管理
  {
    path: "/financial/bills/invoiceManage",
    name: "invoiceManage",
    meta: { title: "GPUEZ智算云 - 发票管理" },
    component: resolve => require(["@/page/control/financial/bills/invoiceManage"], resolve),
  },
  {
    path: "/financial/bills/invoiceInfo",
    name: "invoiceInfo",
    meta: { title: "GPUEZ智算云 - 发票信息" },
    component: resolve => require(["@/page/control/financial/bills/invoiceInfo"], resolve),
  },
  {
    path: "/financial/bills/invoiceData",
    name: "invoiceData",
    meta: { title: "GPUEZ智算云 - 账单列表" },
    component: resolve => require(["@/page/control/financial/bills/invoiceData"], resolve),
  },
  {
    path: "/financial/bills/rechargeInvoice",
    name: "rechargeInvoice",
    meta: { title: "GPUEZ智算云 - 开票" },
    component: resolve => require(["@/page/control/financial/bills/rechargeInvoice"], resolve),
  },
  {
    path: "/financial/gainCash",
    name: "gainCash",
    meta: { title: "GPUEZ智算云 - 佣金提现" },
    component: resolve => require(["@/page/control/financial/gainCash/index"], resolve),
  },


  // 订单管理
  {
    path: "/financial/orders",
    name: "list",
    meta : { title: "GPUEZ智算云 - 订单列表" },
    component: resolve => require(["@/page/control/financial/orders/list"], resolve),
  },
  {
    path: "/financial/orders/respack",
    name: "respack",
    meta : { title: "GPUEZ智算云 - 资源包管理" },
    component: resolve => require(["@/page/control/financial/orders/respack"], resolve),
  },

  {
    path: "/financial/test/test",
    name: "test",
    meta : { title: "test - test" },
    component: resolve => require(["@/page/control/financial/test/test"], resolve),
  }

]


// WEBPACK FOOTER //
// ./src/router/modules/financialRouter.js